import { render } from "./LeavePage.vue?vue&type=template&id=8d18cebe&scoped=true"
import script from "./LeavePage.vue?vue&type=script&lang=js"
export * from "./LeavePage.vue?vue&type=script&lang=js"

import "./LeavePage.vue?vue&type=style&index=0&id=8d18cebe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d18cebe"]])

export default __exports__